import http from '@/assets/common/http';

export function queryPerson(data) {
  const params = {
    SERVICE_ID: '10172',
    OTYPE: 4,
    ...data,
  };
  return http.post(params);
}
// 禁止
export function stopPerson(data) {
  const params = {
    SERVICE_ID: '10172',
    OTYPE: 2,
    ...data,
  };
  return http.post(params);
}
// 启用
export function startPerson(data) {
  const params = {
    SERVICE_ID: '10172',
    OTYPE: 6,
    ...data,
  };
  return http.post(params);
}
// 修改人员
export function editPerson(data) {
  const params = {
    SERVICE_ID: '10172',
    OTYPE: 3,
    ...data,
  };
  return http.post(params);
}
// 新增人员
export function addPerson(data) {
  const params = {
    SERVICE_ID: '10172',
    OTYPE: 1,
    ...data,
  };
  return http.post(params);
}
// 解除匹配
export function stopMatch(data) {
  const params = {
    SERVICE_ID: '91009',
    OTYPE: 2,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉去匹配的角色
export function queryRole(data) {
  const params = {
    SERVICE_ID: '91009',
    OTYPE: 4,
    ...data,
  };
  return http.post(params);
}
// 拉去未匹配的角色
export function queryRoleData(data) {
  const params = {
    SERVICE_ID: '91009',
    OTYPE: 5,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 匹配角色
export function matchRole(data) {
  const params = {
    SERVICE_ID: '91009',
    OTYPE: 1,
    ...data,
  };
  return http.post(params);
}
// 重置密码
export function initPWD(data) {
  const params = {
    SERVICE_ID: '91000',
    OTYPE: 6,
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/assets/api/accountManage.js